var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { accountDetails } from "../../../../../mainDi/webDi";
import { AccountPopupsEnum, ELoginPopupState, toggleaccTypes, } from "./constant";
import { Col, Row } from "react-bootstrap";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import di from "@frameworks/web/components/features/BasicProfile/di/servicelocator";
import { useNavigate } from "react-router-dom";
import Loader from "@frameworks/web/components/generic/loader";
import { clearStorageOnLogout } from "@frameworks/web/components/constant";
import * as URLConfig from "@frameworks/web/config/domain";
var AccountsPopups = function (props) {
    var device = DeviceContext();
    var navigate = useNavigate();
    var _a = __read(useState(""), 2), failureMsg = _a[0], setFailureMsg = _a[1];
    var config = URLConfig.config;
    // function redirectToNuvamaIfEQ(props: {
    //   accType: string;
    //   mergeStatus: string;
    // }) {
    //   if (props && props?.accType === "EQ") {
    //     window.open(
    //       config.oldWebUrl +
    //         "app/clientarea/service-request/segment-activation?source=ajs"
    //     );
    //   }
    // }
    var checkcommodity = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            if (((_a = props === null || props === void 0 ? void 0 : props.accountState) === null || _a === void 0 ? void 0 : _a.accType) === "CO" ||
                ((_b = props === null || props === void 0 ? void 0 : props.accountState) === null || _b === void 0 ? void 0 : _b.accType) === "EQ") {
                // localStorage.clear();
                if (((_c = props === null || props === void 0 ? void 0 : props.accountState) === null || _c === void 0 ? void 0 : _c.mergeStatus) === ELoginPopupState.NOT_ENABLED) {
                    clearStorageOnLogout();
                    navigate("/login");
                    window.location.reload();
                }
                else {
                    if (((_d = props === null || props === void 0 ? void 0 : props.accountState) === null || _d === void 0 ? void 0 : _d.accType) === "EQ") {
                        window.open(config.oldWebUrl +
                            "app/clientarea/service-request/segment-activation?source=ajs");
                    }
                    else {
                        clearStorageOnLogout();
                        navigate("/login");
                        window.location.reload();
                    }
                }
            }
            else if (((_e = props === null || props === void 0 ? void 0 : props.accountState) === null || _e === void 0 ? void 0 : _e.accType) === "COMEQ") {
                // localStorage.clear();
                clearStorageOnLogout();
                navigate("/login");
                window.location.reload();
            }
            else {
                props === null || props === void 0 ? void 0 : props.setScreenState(AccountPopupsEnum.NEW_ACCOUNT);
            }
            return [2 /*return*/];
        });
    }); };
    var handleScreenAccToState = function () {
        var _a, _b, _c;
        switch (props === null || props === void 0 ? void 0 : props.screenState) {
            case AccountPopupsEnum.NRI_ACCOUNT:
                return (React.createElement(React.Fragment, null,
                    React.createElement(Row, null,
                        React.createElement(Col, { lg: 12 },
                            React.createElement("div", { className: "".concat((device === null || device === void 0 ? void 0 : device.isDesktop)
                                    ? "DMSanN_18_400  text-center text-popup "
                                    : "text-center popup-nri-basic-profile  DMSanN_14_400") }, "You are an NRI customer. This feature is available only for Resident Individual clients having both trading and demat account with us. Please reach out to your RM or call servicing team 18001023335."))),
                    React.createElement("div", { className: "d-flex justify-content-center gap-3 twobutton-of-popup" },
                        React.createElement("div", { className: "no-button" },
                            React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Back", className: "", onClick: function () {
                                    props === null || props === void 0 ? void 0 : props.setScreenState(AccountPopupsEnum.DEFAULT);
                                    (props === null || props === void 0 ? void 0 : props.callBackFunction) && (props === null || props === void 0 ? void 0 : props.callBackFunction());
                                } })))));
            case AccountPopupsEnum.SWITCH_TO_OTHER_ACC:
                return (React.createElement(React.Fragment, null,
                    React.createElement(Row, null,
                        React.createElement(Col, { lg: 12 },
                            React.createElement("div", { className: "".concat((device === null || device === void 0 ? void 0 : device.isDesktop)
                                    ? "DMSanN_18_400 text-center text-popup "
                                    : "text-left text-popup  DMSanN_14_400") },
                                "Are you sure you want to switch to your",
                                " ",
                                ((_a = props === null || props === void 0 ? void 0 : props.accountState) === null || _a === void 0 ? void 0 : _a.accType) !== "COMEQ"
                                    ? toggleaccTypes[(_b = props === null || props === void 0 ? void 0 : props.accountState) === null || _b === void 0 ? void 0 : _b.accType]
                                    : toggleaccTypes[props === null || props === void 0 ? void 0 : props.toggledAcc],
                                " ",
                                "account?",
                                " "))),
                    React.createElement("div", { className: "d-flex justify-content-center gap-3 twobutton-of-popup" },
                        React.createElement("div", { className: "no-button" }, (props === null || props === void 0 ? void 0 : props.btnvalueleft) ? (React.createElement(EdButton, __assign({ className: "small-edbutton" }, props.btnvalueleft, { onClick: function () {
                                props === null || props === void 0 ? void 0 : props.setScreenState(AccountPopupsEnum.DEFAULT);
                                (props === null || props === void 0 ? void 0 : props.callBackFunction) && (props === null || props === void 0 ? void 0 : props.callBackFunction());
                            } }))) : (React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "No", className: "", onClick: function () {
                                props === null || props === void 0 ? void 0 : props.setScreenState(AccountPopupsEnum.DEFAULT);
                                (props === null || props === void 0 ? void 0 : props.callBackFunction) && (props === null || props === void 0 ? void 0 : props.callBackFunction());
                            } }))),
                        React.createElement("div", { className: "yes-button" }, (props === null || props === void 0 ? void 0 : props.btnvalueright) ? (React.createElement(EdButton, __assign({ className: "small-edbutton small-cancel-btn" }, props.btnvalueright, { onClick: checkcommodity }))) : (React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Yes", className: "small-cancel-btn", onClick: checkcommodity }))))));
            case AccountPopupsEnum.NEW_ACCOUNT:
                return (React.createElement(React.Fragment, null,
                    React.createElement(Row, null,
                        React.createElement(Col, { lg: 12 }, device && device.isDesktop ? (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "DMSanN_18_400 text-center p-0" },
                                React.createElement("span", { className: "DMSansBold_20_700 mt-3" },
                                    React.createElement("strong", { className: "txt_blackOne1" },
                                        "You will need a",
                                        " ",
                                        (props === null || props === void 0 ? void 0 : props.accountState.accType) === "EQ"
                                            ? "Commodity"
                                            : "Equity",
                                        "\u00A0account to transact in\u00A0",
                                        (props === null || props === void 0 ? void 0 : props.accountState.accType) === "EQ"
                                            ? "Commodities"
                                            : "Equities")),
                                React.createElement("p", { className: "mb-0 DMSanN_18_400 txt_blackOne1" }, "Would you like to open one now?")))) : (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "text-left p-3" },
                                React.createElement("span", { className: "DMSan_14_700" },
                                    React.createElement("strong", null,
                                        "You will need a",
                                        " ",
                                        (props === null || props === void 0 ? void 0 : props.accountState.accType) === "EQ"
                                            ? "Commodity"
                                            : "Equity",
                                        "\u00A0account to transact in\u00A0",
                                        (props === null || props === void 0 ? void 0 : props.accountState.accType) === "EQ"
                                            ? "Commodities"
                                            : "Equities")),
                                React.createElement("p", { className: "mb-0 DMSanN_14_400 mt-2" }, "Would you like to open one now?")))))),
                    React.createElement("div", { className: "d-flex justify-content-center gap-3 twobutton-of-popup" },
                        React.createElement("div", { className: "no-button" }, (props === null || props === void 0 ? void 0 : props.btnvalueleft) ? (React.createElement(EdButton, __assign({}, props.btnvalueleft, { onClick: function () {
                                props === null || props === void 0 ? void 0 : props.setScreenState(AccountPopupsEnum.DEFAULT);
                                (props === null || props === void 0 ? void 0 : props.callBackFunction) && (props === null || props === void 0 ? void 0 : props.callBackFunction());
                            } }))) : (React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "No", className: "w-100", onClick: function () {
                                props === null || props === void 0 ? void 0 : props.setScreenState(AccountPopupsEnum.DEFAULT);
                                (props === null || props === void 0 ? void 0 : props.callBackFunction) && (props === null || props === void 0 ? void 0 : props.callBackFunction());
                            } }))),
                        React.createElement("div", { className: "yes-button" }, (props === null || props === void 0 ? void 0 : props.btnvalueright) &&
                            ((_c = props === null || props === void 0 ? void 0 : props.accountState) === null || _c === void 0 ? void 0 : _c.accType) === "EQ" ? (React.createElement(EdButton, __assign({}, props.btnvalueright, { onClick: function () {
                                return window.open(config.oldWebUrl +
                                    "app/clientarea/service-request/segment-activation?source=ajs");
                            } }))) : (React.createElement(EdButton, { btnTyp: "midnight-blue", value: "yes", className: "w-100", onClick: function () { return openNewAccount(); } }))))));
            case AccountPopupsEnum.SUCCESS_RESULT:
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "DMSanN_18_400 text-center p-3" },
                        React.createElement("span", { className: "txt_green" }, "We've received yout request!"),
                        React.createElement("div", null, "Our representative will get in touch with you shortly"))));
            case AccountPopupsEnum.FAILED_RESULT:
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "DMSanN_18_400 text-center p-3" }, failureMsg ? (React.createElement("span", null, failureMsg)) : ("Error in registering. Please try again"))));
            case AccountPopupsEnum.LOADER:
                return (React.createElement("div", { className: "mt-20 mb-20" },
                    React.createElement(Loader, null),
                    ";"));
        }
    };
    var openNewAccount = function () { return __awaiter(void 0, void 0, void 0, function () {
        var eqName, email, coAccName, phone, acCode, accType, userId, payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    props === null || props === void 0 ? void 0 : props.setScreenState(AccountPopupsEnum.LOADER);
                    setFailureMsg("");
                    if (!((props === null || props === void 0 ? void 0 : props.accountState.mergeStatus) === ELoginPopupState.ONE_ACCOUNT)) return [3 /*break*/, 9];
                    return [4 /*yield*/, accountDetails.getEqAccName()];
                case 1:
                    eqName = _a.sent();
                    return [4 /*yield*/, accountDetails.getEmailId()];
                case 2:
                    email = _a.sent();
                    return [4 /*yield*/, accountDetails.getCoAccName()];
                case 3:
                    coAccName = _a.sent();
                    return [4 /*yield*/, accountDetails.getAccPhoneNo()];
                case 4:
                    phone = _a.sent();
                    return [4 /*yield*/, (accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.getAccountCode())];
                case 5:
                    acCode = _a.sent();
                    return [4 /*yield*/, (accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.getAccTyp())];
                case 6:
                    accType = _a.sent();
                    return [4 /*yield*/, (accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.getUserID())];
                case 7:
                    userId = _a.sent();
                    payload = {
                        name: coAccName,
                        email: email,
                        Phone: phone,
                        categoryId: 220,
                        productId: 49,
                        subCategoryId: 529,
                        acCode: acCode,
                        accType: accType,
                        userId: userId,
                    };
                    return [4 /*yield*/, di.basicProfile
                            .saveLeadData(payload)
                            .then(function (data) {
                            if (data) {
                                if (data.data.Response.toLocaleLowerCase() === "failure") {
                                    props === null || props === void 0 ? void 0 : props.setScreenState(AccountPopupsEnum.FAILED_RESULT);
                                    setFailureMsg(data.data.ResponseDescription);
                                }
                                else {
                                    props === null || props === void 0 ? void 0 : props.setScreenState(AccountPopupsEnum.SUCCESS_RESULT);
                                }
                            }
                        })
                            .catch(function (err) {
                            props === null || props === void 0 ? void 0 : props.setScreenState(AccountPopupsEnum.FAILED_RESULT);
                        })];
                case 8:
                    _a.sent();
                    _a.label = 9;
                case 9: return [2 /*return*/];
            }
        });
    }); };
    return React.createElement("div", null, handleScreenAccToState());
};
export default AccountsPopups;
